import { useNavigate } from 'react-router-dom';
import { Loader } from '@thinknet-gmbh/platform-common-ui';

import { EditDatevForm } from 'src/pages/settings/components/datev/components/edit-datev-number/components/edit-datev-form';
import { useGetDatevNumberById } from 'src/hooks/datev-numbers/get-datev-number-by-id.hook';
import { useUpdateDatevNumber } from 'src/hooks/datev-numbers/update-datev-number.hook';
import { ROUTES } from 'src/components/app/app-routes.constants';
import { SETTINGS_PAGES } from 'src/pages/settings/settings.constants';

const EditClientNumber = ({ clientNumberId }: { clientNumberId: string }) => {
  const { datevNumber, loading } = useGetDatevNumberById(clientNumberId);
  const navigate = useNavigate();

  const updateDatevNumber = useUpdateDatevNumber({
    onSuccess: () => navigate(`${ROUTES.settings}?type=${SETTINGS_PAGES.datev}`),
  });

  const onFinishHandler = (values: any) => {
    updateDatevNumber({
      variables: {
        payload: { ...values, datevNumber: values.datevNumber.toString(), _id: datevNumber._id },
      },
    });
  };

  return loading ? (
    <Loader />
  ) : (
    <EditDatevForm data={datevNumber} onFinishHandler={onFinishHandler} />
  );
};

export default EditClientNumber;
